module.exports = {
    API_ENDPOINT:        'https://api.cloudglass.es/cloudmasaws',
    WEBSOCKET_ENDPOINT:  'wss://api.cloudglass.es/',
    API_CLIENT_ID:       'OwwIHmK0nOA9AikXSAaWuBo1yd6jDPUOTtuonj5O',
    API_CLIENT_SECRET:   'TDtm5nTanZ2hRozqzEtoyHRDzFaC5ZWa4bSnng3OeNOPm7MbQJio3k1W1Oi9fCbsB1545c3ccFwIQQKCWqMUwqFFDkXDmbgtOReZ5i6C5NUnTzFNhBOwcYoKqsJl0Pdb',
    API_METHOD_PREFIX:   'api/',
    SHOW_MOCKS:          'undefined',
    GOOGLE_ANALYTICS_ID: 'UA-134286230-1',
    AVAILABLE_LANGUAGES: ['en', 'es']
};



//////////////////
// WEBPACK FOOTER
// ./src/config/config.js
// module id = 79
// module chunks = 49